import React from 'react'
import styles from './status-pulling.styles'
import injectSheet from 'react-jss'
import StatusColor from '../shared/status-color/status-color'

const StatusPulling = ({ classes, id, statusColor }) => (
  <div className={classes.status}>
    <StatusColor color={statusColor} />
    <div>
      <p className={classes.msg}>
        Import in process. This can take several minutes to complete. In case of
        questions contact <a href="mailto:hello@pobble.com">hello@pobble.com</a>
        .
      </p>
    </div>
  </div>
)

export default injectSheet(styles)(StatusPulling)
